import {
  GET_ALL_QR,
  QR_LOADING_START,
  QR_LOADING_END,
  SET_ERROR,
} from "../actions/QRCodes/types";
const initialState = {
  isLoading: false,
  qrCodes: [],
  error: null,
};

const qrReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_QR:
      return { ...state, qrCodes: payload };
    case QR_LOADING_START:
      return { ...state, isLoading: true };
    case QR_LOADING_END:
      return { ...state, isLoading: false };
    case SET_ERROR:
      return { ...state, error: payload };

    default:
      return state;
  }
};
export default qrReducer;
